import { data } from "../charts/c1";
import { SendBookingMailer } from "../pricing/pricing.screen"
import Utils from "../util/Utils";
import Api from "./Api"
import { bookingsStore, contractsStore, configStore } from "./CommonState"
const BOOKINGSURI = {
    GET4CONTRACT: (contractNum) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/contract/${contractNum}`,
    GET: (bookingNum) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/${bookingNum}`,
    GET_FOR_CONSOLE: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/planning`,
    BOOKING_WITH_ENTITIE: (bookingNum) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/withentities/${bookingNum}`,
    GETALL: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings`,
    GETALLBOOKINGS: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/getallbookings`,
    POST: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings`,
    UPDATE_PLANNING_STATUS: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/updatePlanning`,
    GET_CONTAINERS: (containerStatus, page, get) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/container/${containerStatus}/${page}/${get}`,
    GET_CONTAINER_LIST: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/container/getall`,
    UPDATE_CONTAINER: `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/container`,
    CANCEL_BOOKING: (id) =>  `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/cancelBooking/${id}`,
    SETCUSTREF_BOOKING: (id) =>  `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/setCustref/${id}`,
    SETFBADETAILS_BOOKING: (id) =>  `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/setFbadetails/${id}`,
    SENDLINK : (id)=>`${process.env.REACT_APP_API_SERVER}/api/v1/trackmybookings/sharebooking/${id}`,
    DOWNLOAD_STUFFING_SHEET: (consoleId) => `${process.env.REACT_APP_API_SERVER}/api/v1/bookings/downloadStuffingSheet/${consoleId}`,
}
export default class BookingsApi {
    static getAllBookings(callback = f => f) {
        // Api.fetch(BOOKINGSURI.GETALL, (data) => {
        //     bookingsStore.list = data
        //     callback(data)
        // })
    }
static async downloadStuffingSheet(consoleId) {
  const url = BOOKINGSURI.DOWNLOAD_STUFFING_SHEET(consoleId);

  try {
    const res = await fetch(url, {
      headers: Api.H(),
      credentials: Utils.shouldSendCredentials(url) ? 'include' : 'omit',
    });

    if (!res.ok) throw new Error(`Download failed: ${res.status}`);

    // Read as JSON
    const data = await res.json();

    // Convert base64 to Blob
    const blob = Utils.b64toBlob(data.base64, data.mimeType);

    // Trigger download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = data.fileName;
    link.click();
    URL.revokeObjectURL(link.href);

    return true;

  } catch (err) {
    console.error('Download error:', err);
    configStore.setModalMessage(err?.message || 'Failed to download stuffing sheet');
    return false;
  }
}

    static getAllBookingsNew(BkNumdata ,callback = f => f) {
        Api.post(BOOKINGSURI.GETALLBOOKINGS , BkNumdata ,  (data) => {
            callback(data)
        })
    }

    static sendTrackBookingLink(bookingDetail){
        const {id,...reqBody} = bookingDetail;
        Api.post(BOOKINGSURI.SENDLINK(id),reqBody);
    }

    static getBookingWithEntitie(bookingNum, callback = f => f) {
        Api.fetch(BOOKINGSURI.BOOKING_WITH_ENTITIE(bookingNum), (data) => {
            callback(data)
        })
    }

    static getBookingsForConsole(details, callback = f => f) {
        Api.post(BOOKINGSURI.GET_FOR_CONSOLE, details, (data) => {
            callback(data)
        })
    }
   static updatePlanningStatus(details, callback) {
        Api.put(BOOKINGSURI.UPDATE_PLANNING_STATUS,details,() => {
            if(callback){
                callback();
            }
            configStore.setModalMessage(`${details.planningStatus === 'image'? `Images saved`:`Planning status moved to ${details.planningStatus}`}`)
        } )
    }
   static updateContainer(details, callback) {
    Api.put(BOOKINGSURI.UPDATE_CONTAINER, details, (response) => {
        if (response?.message) {
            configStore.setModalMessage(response.message);
        } else {
            configStore.setModalMessage(`Container ${details._id} updated successfully`);
        }

        if (callback) {
            callback(response);
        }
    });
}

       static getContainers(containerStatus, page, get, callback = f => f) {
        console.log("Fetching containers for status:", containerStatus, "Page:", page);
        
        Api.fetch(BOOKINGSURI.GET_CONTAINERS(containerStatus, page, get), (data) => {
            console.log("Received container data:", data);
            
            callback(data)
        })
    }
    static getContainerList( callback = f => f) {
        
        Api.fetch(BOOKINGSURI.GET_CONTAINER_LIST, (data) => {
            callback(data)
        })
    }


    static getBooking(bookingNum, callback = f => f) {
        Api.fetch(BOOKINGSURI.GET(bookingNum), (data) => {
            let stype = data.contract.shipmentType.substr(0, 3).toLowerCase()
            if(stype=='air'){
                if(data.contract.airline != undefined && data.contract.airline.trim().length==0 && data.airline != undefined && data.airline.trim().length!=0){
                    data.contract.airline = data.airline
                }
            }
            bookingsStore.current = data
            callback(data)
        })
    }
    static getForContract(contractNum, callback = f => f) {
        Api.fetch(BOOKINGSURI.GET4CONTRACT(contractNum), (data) => {
            bookingsStore.list = data
            callback(data)
        })
    }
    
    static saveBooking(shipperConsignee,callback,booking = (f) => f,errCallback) {
        const getcharge = (d,b)=>{
            let a = {}
            let l = []
            for (let i = 0; i < b.contract.chargesList.length; i++) {
                let c = b.contract.chargesList[i]
                const k = (c,a) =>{
                    a[c["chargeDescription"]] = {}
                    let o = Object.keys(c)
                    o = o.filter(item => !["chargeDescription","onaccount","isIncluded"].includes(item))
                    for (let j = 0; j < o.length; j++) {
                        a[c["chargeDescription"]][o[j]] = c[o[j]]
                    }
                    return a
                }
                if(c["onaccount"]==undefined && d=="On Your Account"){
                    a = k(c,a)
                    l.push(c)
                }
                if(c["onaccount"]!=undefined && c["onaccount"]==d){
                    a = k(c,a)
                    l.push(c)
                }
            }
            return {"charge":a,"list":l}
        }
        let b = {bookingData:bookingsStore.current, shipperConsignee: shipperConsignee}
        if(((b.bookingData.createdFromPricing!=undefined && b.bookingData.createdFromPricing && b.bookingData.cartingsheetId==undefined) || (b.bookingData.createdFromPricingCarting!=undefined && b.bookingData.createdFromPricingCarting)) && b.bookingData.contract.shipmentType.indexOf("LCL") >= 0){

                const setperShipment = (list)=>{
                    let l = []
                    if(list!=undefined && list.length>0){
                        for (let i = 0; i < list.length; i++) {
                            let z = list[i]
                            z['maximum'] = 0
                            z['minimum'] = 0
                            z['perCBM'] = 0
                            z['perTon'] = 0
                            z['perShipment'] = z['total']
                            l.push(z)
                        }
                    }
                    return l
                }
                b.bookingData.contract.shipperchargesList = setperShipment(b.bookingData.contract.shipperchargesList)
                b.bookingData.contract.consigneechargesList = setperShipment(b.bookingData.contract.consigneechargesList)
                b.bookingData.contract.chargesList = setperShipment(b.bookingData.contract.chargesList)
            
        }
         
        if(b.createdFromPricing!=undefined && b.createdFromPricing){
            if(b.contract.shippercharges==undefined){
                let k = getcharge("Shipper's Account",b)
                if(Object.keys(k["charge"]).length>0){
                    b.contract.shippercharges = k["charge"]
                }
                if(k["list"].length>0){
                    b.contract.shipperchargesList = k["list"]
                }
            }
            if(b.contract.consigneecharges==undefined){
                let k = getcharge("Consignee's Account",b)
                if(Object.keys(k["charge"]).length>0){
                    b.contract.consigneecharges = k["charge"]
                }
                if(k["list"].length>0){
                    b.contract.consigneechargesList = k["list"]
                }
            }
            if(b.contract.charges==undefined){
                let k = getcharge("On Your Account",b)
                if(Object.keys(k["charge"]).length>0){
                    b.contract.charges = k["charge"]
                }
                if(k["list"].length>0){
                    b.contract.chargesList = k["list"]
                }
            }
        }
        Api.post(BOOKINGSURI.POST, b, (data) => {
            //if (fromPricing) SendBookingMailer(data)
            booking(data)
            configStore.setBookingModalMessage(data._id)
            callback(data)
        },errCallback)
    }

    static cancelBooking(bookingNum,reason,callback) {
        Api.put(BOOKINGSURI.CANCEL_BOOKING(bookingNum),{ reason },() => {
            // configStore.setModalMessage(`Booking ${bookingNum} Cancelled`)
            if(callback){
                callback();
            }
            configStore.setModalMessage(`Booking Cancellation request placed successfully`)
        } )
    }

    static cancelBookingfromqoute(bookingNum,reason) {
        Api.put(BOOKINGSURI.CANCEL_BOOKING(bookingNum),{ reason },() => {
            // configStore.setModalMessage(`Booking ${bookingNum} Cancelled`)
        } )
    }

    static setcustrefBooking(bookingNum,contract) {
        Api.put(BOOKINGSURI.SETCUSTREF_BOOKING(bookingNum),{ contract },() => {
            configStore.setModalMessage(`Booking ${bookingNum} - Cust Ref Changed.`)
        } )
    }

    static setfbadetailsBooking(bookingNum,fbaDetails,merchantID,msg=true,callback) {
        Api.put(BOOKINGSURI.SETFBADETAILS_BOOKING(bookingNum),{ fbaDetails:fbaDetails,merchantID:merchantID },() => {
            if(msg){
                configStore.setModalMessage(`Booking ${bookingNum} - FBA Details Changed.`)
            }
            if(callback){
                callback()
            }
        } )
    }
}